export default __webpack_public_path__ + "static/media/fig9.9059b7ce.jpg";